// Development deployment environment configuration for Pams Outlook Add-in
export const environment = {
  production: false,
  apiUrl: 'https://dev-api.pams.net/',
  oneDriveApiUrl: 'https://core.pams.net/api/',
  addinUrl: 'https://outlook-dev.pams.net/',
  
  // Azure AD Configuration
  azureAd: {
    clientId: 'd9801208-fe70-4b23-bc46-824b01f7ea72',
    authority: 'https://login.microsoftonline.com/common',
    redirectUri: 'https://outlook-dev.pams.net/taskpane.html',
    scopes: [
      'https://graph.microsoft.com/Calendars.ReadWrite',
      'https://graph.microsoft.com/User.Read',
      'openid',
      'profile'
    ]
  }
};
